<template>
  <div>
    <div class="accordion">
      <div class="accordion__body">
        <div class="accordion__form" style="max-width: 1180px;">
          <div class="accordion__part">
            <div class="accordion__name">
              <img src="@/assets/img/personal-details.svg" alt="personal">
              <span>Personal details</span>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="First name" label-for="first_name" required>
                <app-input
                  v-model="personal.first_name"
                  @change.native="$v.personal.first_name.$touch()"
                  :error="$v.personal.first_name.$error"
                  id="first_name"
                  placeholder="John"
                  name="first_name"
                />
                <template #error>
                  <div v-if="$v.personal.first_name.$dirty && !$v.personal.first_name.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Middle name" label-for="middle_name">
                <app-input
                  v-model="personal.middle_name"
                  id="middle_name"
                  placeholder="Emily"
                  name="middle_name"
                />
              </app-form-group>
              <app-form-group label="Last name" label-for="last_name" required>
                <app-input
                  v-model="personal.last_name"
                  @change.native="$v.personal.last_name.$touch()"
                  :error="$v.personal.first_name.$error"
                  id="last_name"
                  placeholder="Doe"
                  name="last_name"
                />
                <template #error>
                  <div v-if="$v.personal.last_name.$dirty && !$v.personal.last_name.required">Required field</div>
                </template>
              </app-form-group>
              <app-form-group label="Gender" class="form-group--center">
                <app-cells :indent="false">
                  <app-radio
                    v-for="item in genders_options"
                    :key="item.code"
                    v-model.number="personal.gender"
                    :value="item.code"
                    name="gender"
                    :checked="personal.gender.code"
                  >
                    <template #label>{{ item.name }}</template>
                  </app-radio>
                </app-cells>
              </app-form-group>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Date of birth">
                <app-date-picker
                  @input="onCheckBirth"
                  v-model="personal.dob"
                  placeholder="Specify a date"
                  :error="$v.personal.dob.$error || $v.age.$invalid"
                />
                <template #error>
                  <div v-if="$v.personal.dob.$dirty && !$v.age.between">Age must be from 16 to 90 years old{{ age ? `, current age: ${age}` : '' }}</div>
                </template>
              </app-form-group>
              <app-form-group label="Birth certificate">
                <app-uploader
                  v-model="personal.birth_certificate"
                  :extensions="['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/zip', 'application/pdf', 'image/jpeg', 'image/png', 'image/tiff', 'image/bmp']"
                  formDataFormats="DOC,DOCX,XLS,XLSX,ZIP,PDF,JPEG,BMP,PNG,TIFF"
                  class="custom-uploader--flex"
                />
              </app-form-group>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Region">
                <app-select
                  v-model="region"
                  :options="regions_options"
                  placeholder="Region"
                />
              </app-form-group>
              <app-form-group label="Village">
                <app-select
                  v-model="village"
                  :options="villages_options"
                  placeholder="Village"
                />
              </app-form-group>
            </div>
            <app-form-group>
              <app-cropper-web-cam
                v-model="personal.crop"
                :aspectRatio="3/4"
                ref="cropper"
              >
                <template #title>Upload photo</template>
                <template #text>
                  <ul>
                    <li>Accepted formats: JPG, JPEG, BMP, PNG, TIFF, TIF, PDF</li>
                    <li>Maximum size: 5 MB</li>
                  </ul>
                </template>
              </app-cropper-web-cam>
            </app-form-group>
          </div>
          <div class="accordion__part">
            <div class="accordion__name">
              <img src="@/assets/img/contact-details.svg" alt="contact">
              <span>Contacts details</span>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Main phone">
                <app-phone
                  @change.native="$v.personal.phone.$touch()"
                  v-model="personal.phone"
                  :error="$v.personal.phone.$dirty && personal.phone === 0"
                  placeholder="+255 786 350 350"
                  default_сountry="TZ"
                />
                <template #error>
                  <div v-if="$v.personal.phone.$dirty && personal.phone === 0">
                    Invalid phone number format
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Messengers" class="form-group--center">
                <app-cells :indent="false">
                  <app-checkbox v-model="personal.phone_telegram_available" label="Telegram" />
                  <app-checkbox v-model="personal.phone_whatsapp_available" label="Whatsapp" />
                </app-cells>
              </app-form-group>
              <app-form-group label="Telegram ID" label-for="telegram_id">
                <app-input
                  v-model="personal.telegram_id"
                  id="telegram_id"
                  placeholder="Telegram ID"
                  name="telegram_id"
                />
              </app-form-group>
              <app-form-group label="Telegram username" label-for="telegram_username">
                <app-input
                  v-model="personal.telegram_username"
                  id="telegram_username"
                  placeholder="Telegram username"
                  name="telegram_username"
                />
              </app-form-group>
            </div>
            <div class="accordion__row accordion__row--5">
              <app-form-group label="Additional phone">
                <app-phone
                  @change.native="$v.personal.additional_phone.$touch()"
                  v-model="personal.additional_phone"
                  :error="$v.personal.additional_phone.$dirty && personal.additional_phone === 0"
                  placeholder="+255 786 350 350"
                  default_сountry="TZ"
                />
                <template #error>
                  <div v-if="$v.personal.additional_phone.$dirty && personal.additional_phone === 0">
                    Invalid phone number format
                  </div>
                </template>
              </app-form-group>
              <app-form-group label="Messengers" class="form-group--center">
                <app-cells :indent="false">
                  <app-checkbox v-model="personal.additional_phone_telegram_available" label="Telegram" />
                  <app-checkbox v-model="personal.additional_phone_whatsapp_available" label="Whatsapp" />
                </app-cells>
              </app-form-group>
              <app-form-group label="Email" label-for="email">
                <app-input
                  v-model="personal.email"
                  id="email"
                  type="email"
                  placeholder="mail@example.com"
                  name="email"
                />
              </app-form-group>
            </div>
          </div>
          <app-cells :indent="false" position="end">
            <app-button @click.native="onCheckForm" ref="submit_personal">
              Save
            </app-button>
          </app-cells>
        </div>
      </div>
    </div>
    <app-cells>
      <h2 class="title">Emergency contacts</h2>
      <app-button @click.native="onOpenModalForm" size="small">Add contact</app-button>
    </app-cells>
    <v-client-table
      :data="table_emergency.items"
      :columns="table_emergency.columns"
      :options="table_emergency.options"
      class="table-default"
    >
      <template #h__first_name><div class="table-default__left">Name</div></template>
      <template #first_name="{ row }">
        <div class="table-default__left">{{ row.first_name }} {{ row.last_name }}</div>
      </template>
      <template #relationship="{ row }">{{ row.relationship.name }}</template>
      <template #controls="{ row }">
        <div class="table-default__controls">
          <button @click="onShowModalEdit(row)" type="button">
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <button @click="onShowModalDelete(row)" type="button">
            <img src="@/assets/img/delete-table-icon.svg" alt="">
          </button>
        </div>
      </template>
    </v-client-table>
    <modal
      name="contacts"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('contacts')" class="popup__close" type="button"></button>
        <div class="popup__title">{{ current_modal_state === 'create' ? 'Add' : 'Edit' }} emergency contacts</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckModalForm">
            <app-form-group label="First name" label-for="contacts_first_name" required>
              <app-input
                v-model="contacts.first_name"
                @change.native="$v.contacts.first_name.$touch()"
                :error="$v.contacts.first_name.$error"
                id="contacts_first_name"
                placeholder="John"
                name="contacts_first_name"
              />
              <template #error>
                <div v-if="$v.contacts.first_name.$dirty && !$v.contacts.first_name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Last name" label-for="contacts_last_name" required>
              <app-input
                v-model="contacts.last_name"
                @change.native="$v.contacts.last_name.$touch()"
                :error="$v.contacts.last_name.$error"
                id="contacts_last_name"
                placeholder="Doe"
                name="contacts_last_name"
              />
              <template #error>
                <div v-if="$v.contacts.last_name.$dirty && !$v.contacts.last_name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Phone" required>
              <app-phone
                @change.native="$v.contacts.phone.$touch()"
                v-model="contacts.phone"
                placeholder="+255 786 350 350"
                :error="$v.contacts.phone.$dirty && contacts.phone === 0"
              />
              <template #error>
                <div v-if="$v.contacts.phone.$dirty && contacts.phone === 0">
                  Invalid phone number format
                </div>
              </template>
            </app-form-group>
            <app-form-group label="Relationship" required>
              <app-select
                v-model="contacts.relationship"
                :options="relationship_options"
                :reduce="item => item.code"
                placeholder="Relationship"
                :error="$v.contacts.relationship.$error"
              />
              <template #error>
                <div v-if="$v.contacts.relationship.$dirty && !$v.contacts.relationship.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.contacts.$error" type="submit" ref="submit_contacts">
                {{ current_modal_state === 'create' ? 'Add contact' : 'Save' }}
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete-contacts"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-contacts')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete Record
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this emergency contact?</div>
          <div v-if="current_modal_data" class="popup__info">
            {{ current_modal_data.first_name }} {{ current_modal_data.last_name }}
          </div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-contacts')" theme="dark">Cancel</app-button>
            <app-button @click.native="onTableControlsDelete" ref="delete_contact">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { between, required } from 'vuelidate/lib/validators'
import {
  deleteClimbingMountainCrewEmergencyContacts,
  getClimbingMountainCrewEmergencyContacts,
  getDictRelationships,
  getGenders,
  getLocationRegions,
  getLocationVillages,
  patchClimbingMountainCrew,
  patchClimbingMountainCrewEmergencyContacts,
  postClimbingMountainCrewEmergencyContacts,
} from '@/http'
import { differenceInCalendarYears, parseISO } from 'date-fns'

export default {
  name: 'ClimbingMountainCrewProfile',
  props: {
    personal: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      genders_options: [],
      regions_options: [],
      villages_options: [],
      age: 30,
      region: null,
      village: null,
      table_emergency: {
        items: [],
        columns: ['first_name', 'phone', 'relationship', 'controls'],
        options: {
          headings: {
            'first_name': 'Name',
            'phone': 'Phone',
            'relationship': 'Relationship',
            'controls': ''
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      contacts: {},
      current_modal_state: 'create',
      relationship_options: [],
      current_modal_data: {},
    }
  },
  validations: {
    personal: {
      first_name: { required },
      last_name: { required },
      dob: {},
      phone: {},
      additional_phone: {},
    },
    age: { between: between(16, 90) },
    contacts: {
      first_name: { required },
      last_name: { required },
      phone: { required },
      relationship: { required }
    },
  },
  created() {
    getGenders().then(res => { this.genders_options = res.data })
    getLocationRegions().then(res => { this.regions_options = res.data })
    getLocationVillages().then(res => { this.villages_options = res.data })
    this.getEmergencyContactsList()
    getDictRelationships().then(res => { this.relationship_options = res.data })
    this.region = this.personal.region
    this.village = this.personal.village
  },
  methods: {
    onTableControlsDelete() {
      this.$refs.delete_contact.preload = true
      deleteClimbingMountainCrewEmergencyContacts(this.$route.params.id, this.current_modal_data.id)
        .finally(() => { this.$refs.delete_contact.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: `Emergency contact ${this.current_modal_data.first_name} ${this.current_modal_data.last_name} deleted`,
          })
          this.$modal.hide('delete-contacts')
          this.getEmergencyContactsList()
        })
    },
    onCheckModalForm() {
      this.$v.contacts.$touch()
      if (this.$v.contacts.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendModalForm()
      }
    },
    sendModalForm() {
      this.$refs.submit_contacts.preload = true
      if (this.current_modal_state === 'create') {
        postClimbingMountainCrewEmergencyContacts(this.$route.params.id, this.normalizeContacts())
          .finally(() => { this.$refs.submit_contacts.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Emergency contact added',
            })
            this.$modal.hide('contacts')
            this.getEmergencyContactsList()
          })
      } else {
        patchClimbingMountainCrewEmergencyContacts(this.$route.params.id, this.contacts.id, this.normalizeContacts())
          .finally(() => { this.$refs.submit_contacts.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: `Emergency contact ${this.contacts.first_name} ${this.contacts.last_name} saved`,
            })
            this.$modal.hide('contacts')
            this.getEmergencyContactsList()
          })
      }
    },
    normalizeContacts() {
      const normalizedForm = { ...this.contacts }

      if (normalizedForm.relationship && typeof normalizedForm.relationship !== 'string') {
        normalizedForm.relationship = normalizedForm.relationship.code
      }
      return normalizedForm
    },
    getEmergencyContactsList() {
      getClimbingMountainCrewEmergencyContacts(this.$route.params.id)
        .then(res => { this.table_emergency.items = res.data })
    },
    onShowModalEdit(row) {
      this.current_modal_state = 'edit'
      this.contacts = { ...row }
      this.$modal.show('contacts')
    },
    onShowModalDelete(row) {
      this.current_modal_data = row
      this.$modal.show('delete-contacts')
    },
    onOpenModalForm() {
      this.current_modal_state = 'create'
      this.contacts = {}
      this.$v.contacts.$reset()
      this.$modal.show('contacts')
    },
    onCheckForm() {
      if (this.$v.personal.$invalid) {
        this.$notify({
          type: 'error',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        if (this.personal.crop.coords && !this.personal.crop.photo) {
          this.$refs.submit_personal.preload = true
          this.$refs.cropper.sendCrop()
            .then(() => { this.sendForm() })
            .catch(() => { this.$refs.submit_personal.preload = false })
        } else {
          this.sendForm()
        }
      }
    },
    sendForm() {
      this.$refs.submit_personal.preload = true
      patchClimbingMountainCrew(this.$route.params.id, this.normalizePersonal())
        .finally(() => { this.$refs.submit_personal.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved successfully',
          })
        })
    },
    normalizePersonal() {
      const normalizedForm = { ...this.personal }

      if (normalizedForm.birth_certificate && normalizedForm.birth_certificate.id) {
        normalizedForm.birth_certificate = normalizedForm.birth_certificate.id
      }  else normalizedForm.birth_certificate = null
      if (this.region && typeof this.region !== 'number') {
        normalizedForm.region = this.region.id
      }
      if (this.village && typeof this.village !== 'number') {
        normalizedForm.village = this.village.id
      }

      return normalizedForm
    },
    onCheckBirth() {
      this.$v.personal.dob.$touch()
      const date = parseISO(this.personal.dob)
      this.age = differenceInCalendarYears(new Date(), date)
    },
  }
}
</script>
